import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CellRegionPicker } from "@/components/auth/cell-region-picker";

const regionSearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute("/plugin/figma/region")({
  validateSearch: (search) => regionSearchSchema.parse(search),
  component: RegionPicker,
});

function RegionPicker() {
  const { next } = Route.useSearch();
  const target = next ?? "/plugin/figma/sign-up";

  return <CellRegionPicker nextPathCandidate={target} useSpaRedirect />;
}
